import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import CustomModal from "../../../helpers/CustomModal/CustomModal";
import EmptyItems from "../../../helpers/EmptyItems/EmptyItems";
import { notificationWaiterContext } from "../../../context/Waiter/NotificationWaiterContext/NotificationWaiterContext";
import { convertDate } from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const NotificationWaiter = () => {
  const socket = useSelector((state) => state.socket);
  const {
    notifications,
    notification,
    setNotification,
    handleGetNotifications,
    handleDeleteNotification,
    handleDeleteAllNotification,
  } = useContext(notificationWaiterContext);

  useEffect(() => {
    handleGetNotifications();
  }, []);

  useEffect(() => {
    if (!isEmpty(socket)) {
      const updatePositionsHandler = () => handleGetNotifications();

      socket.on("update-notifications", updatePositionsHandler);

      return () => {
        socket.off("update-notifications", updatePositionsHandler);
      };
    }
  }, [socket]);

  return (
    <>
      <SiteTitle title="مدیریت منو" />

      <div className="container-fluid mt-4">
        {!isEmpty(notifications) && (
          <button
            type="button"
            className="kf-btn mb-3"
            onClick={() =>
              areYouSureMessage(
                handleDeleteAllNotification,
                `آیا از حذف همه اطلاعیه ها مطمئنید؟`
              )
            }
          >
            <span>حذف همه</span>
          </button>
        )}

        {isEmpty(notifications) ? (
          <EmptyItems />
        ) : (
          <div className="card">
            <Table responsive hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>عنوان</th>
                  <th>تاریخ</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {notifications.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm:ss")}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn-danger mx-2"
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteNotification(item._id),
                            `آیا از حذف ${item.title} مطمئنید؟`
                          )
                        }
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      <CustomModal
        size="lg"
        title={notification?.title}
        show={!isEmpty(notification)}
        onHide={() => setNotification({})}
      >
        <p>{notification?.description}</p>
      </CustomModal>
    </>
  );
};

export default NotificationWaiter;
